<template lang="pug">
    v-card(color="blue-grey lighten-4" pa-1 v-if="arrayPayments.length > 0")
        v-card-text
            v-layout(row wrap)
                .headline Detalle pagos
            v-data-table(:items="arrayPayments" hide-actions hide-headers)
                template(slot="items" slot-scope="props")
                    td.subtitle
                        v-text-field(
                          hide-details
                          solo
                          flat
                          readonly
                          :value="obtainPaymentMethod(props.item.paymentMethod)")
                    td.subtitle
                        v-text-field(
                          hide-details
                          solo
                          flat
                          readonly
                          :mask="mixCurrencyMask(props.item.payment, 12)"
                          v-model="props.item.payment" prefix="$")
                    td(align="right")
                        v-btn(flat icon :color="colors.danger" @click="deletePayment(props.item.paymentMethod)")
                            v-icon close
</template>

<script>
// Mixins:
import CurrencyUtils from '@/mixins/CurrencyUtils'

import { mapState, mapActions } from 'vuex'
export default {
    name: 'payment-details',
    props: {},
    data: function() {
        return {}
    },
    computed: {
        ...mapState('CashDeskModule', {
            arrayPayments: 'arrayPayments',
            payer: 'payer',
        }),

        paymentMethodsList: function() {
            if (this.payer == 'SC') { // SC: Sale to Client
                return [
                    { text: 'Efectivo', id: 1 },
                    { text: 'Débito', id: 2 },
                    { text: 'Crédito', id: 3 },
                    { text: 'Cheque', id: 4 },
                    { text: 'Factura a crédito (Crédito Cliente)', id: 5}, // solo si es factura
                    { text: 'Transferencia bancaria', id: 6 },
                    { text: 'Nota de Crédito', id: 8 },
                ]
            } else { // SE: Sale to Employee
                return [
                    { text: 'Efectivo', id: 1 },
                    { text: 'Débito', id: 2 },
                    { text: 'Crédito', id: 3 },
                    { text: 'Cheque', id: 4 },
                    { text: 'Descuento Planilla', id: 5 },
                    { text: 'Nota de Crédito', id: 8 },
                ]
            }
        },
    },
    methods: {
        ...mapActions('CashDeskModule', {
            setPaymentArray: 'setPaymentArray',
        }),

        obtainPaymentMethod(id) {
            for (let i = 0; i <= this.paymentMethodsList.length; i++) {
                if (this.paymentMethodsList[i].id === id) {
                    return this.paymentMethodsList[i].text
                }
            }
            return '-'
        },

        deletePayment: function(id) {
            let indexArr = this.arrayPayments.findIndex(
                payment => payment.paymentMethod == id
            )
            let newArray = this.arrayPayments.splice(indexArr, 1)
            this.setPaymentArray(newArray)
        },
    },
    watch: {},
    components: {},
    mixins: [CurrencyUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>
